import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import dayjs from 'dayjs';
import GenericTable from '../tables/GenericTable';
import Pagination from '../layout/Pagination';
import { getDoctorDirectReferrals } from '../../api/medics-api';

/**
 * Reverse of the referral chain (which only shows upline) — lists other
 * doctors whose direct referrer (referredByDoctor) is this doctor.
 */
const DirectReferralsModal = ({ isOpen, onClose, doctorId }) => {
  const [items, setItems] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);

  const loadItems = async (page = 1) => {
    if (!doctorId) return;
    setLoading(true);
    const { data, success } = await getDoctorDirectReferrals(doctorId, {
      page,
      limit: 10,
    });
    setLoading(false);
    if (!success) return;
    setItems(data?.items || []);
    setTotalPages(data?.totalPages || 1);
    setCurrentPage(data?.currentPage || 1);
  };

  useEffect(() => {
    if (isOpen) loadItems(1);
  }, [isOpen, doctorId]);

  const columns = [
    {
      key: 'name',
      label: 'Ime i prezime',
      render: (_, row) => `${row.firstName || ''} ${row.lastName || ''}`,
    },
    { key: 'email', label: 'Email', render: (_, row) => row.email || '-' },
    {
      key: 'referralCode',
      label: 'Referral kod',
      render: (_, row) => row.referralCode || '-',
    },
    {
      key: 'clinic',
      label: 'Organizacija',
      render: (_, row) => row.clinic?.name || '-',
    },
    {
      key: 'createdAt',
      label: 'Datum dodavanja',
      render: (_, row) =>
        row.createdAt ? dayjs(row.createdAt).format('DD.MM.YYYY.') : '-',
    },
  ];

  return (
    <Modal
      className="create_user_modal direct_referrals_modal"
      title="Dodati mentori"
      open={isOpen}
      onCancel={onClose}
      footer={null}
    >
      <GenericTable
        data={loading ? [] : items}
        columns={columns}
        grayTheme={false}
        emptyState={{
          icon: '',
          title: loading ? 'Učitavanje...' : 'Nema mentora',
        }}
      />
      {items.length > 0 && (
        <div style={{ marginTop: 16 }}>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={loadItems}
          />
        </div>
      )}
    </Modal>
  );
};

DirectReferralsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  doctorId: PropTypes.string,
};

export default DirectReferralsModal;
